import Vue from 'vue'

const DEFAULT_INTERVAL_MS = 5 * 60 * 1000 // 5 minutos
const VERSION_URL = '/version.json'

const currentVersion =
    typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : null
const currentBuildTime =
    typeof __APP_BUILD_TIME__ !== 'undefined' ? __APP_BUILD_TIME__ : null

export const buildVersionState = Vue.observable({
    currentVersion,
    currentBuildTime,
    serverVersion: null,
    serverBuildTime: null,
    updateAvailable: false,
})

let timerId = null
let isFetching = false

async function fetchServerVersion() {
    if (isFetching) return
    isFetching = true
    try {
        const url = `${VERSION_URL}?t=${Date.now()}`
        const response = await fetch(url, {
            method: 'GET',
            cache: 'no-store',
            headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cache',
                Expires: '0',
            },
            credentials: 'omit',
        })

        if (!response.ok) return

        const data = await response.json()
        if (!data || !data.version) return

        buildVersionState.serverVersion = data.version
        buildVersionState.serverBuildTime = data.buildTime || null

        if (
            buildVersionState.currentVersion &&
            data.version !== buildVersionState.currentVersion
        ) {
            buildVersionState.updateAvailable = true
        }
    } catch (e) {
        // Falha silenciosa: rede indisponível, dev sem version.json, etc.
    } finally {
        isFetching = false
    }
}

function handleVisibilityChange() {
    if (document.visibilityState === 'visible') {
        fetchServerVersion()
    }
}

export function startBuildVersionChecker(intervalMs = DEFAULT_INTERVAL_MS) {
    if (!buildVersionState.currentVersion) return
    if (timerId !== null) return

    fetchServerVersion()
    timerId = window.setInterval(fetchServerVersion, intervalMs)
    document.addEventListener('visibilitychange', handleVisibilityChange)
    window.addEventListener('focus', fetchServerVersion)
}

export function stopBuildVersionChecker() {
    if (timerId !== null) {
        window.clearInterval(timerId)
        timerId = null
    }
    document.removeEventListener('visibilitychange', handleVisibilityChange)
    window.removeEventListener('focus', fetchServerVersion)
}

export async function forceApplyUpdate() {
    try {
        if ('caches' in window) {
            const keys = await caches.keys()
            await Promise.all(keys.map(k => caches.delete(k)))
        }
    } catch (e) {
        // ignora
    }

    try {
        if ('serviceWorker' in navigator) {
            const regs = await navigator.serviceWorker.getRegistrations()
            await Promise.all(regs.map(r => r.unregister()))
        }
    } catch (e) {
        // ignora
    }

    const url = new URL(window.location.href)
    url.searchParams.set('_v', Date.now().toString())
    window.location.replace(url.toString())
}

export function dismissUpdate() {
    buildVersionState.updateAvailable = false
}
